import { Flag } from "lucide-react";
import {
  DropdownMenuCheckboxItem,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/hooks/use-auth";
import { useFeatureFlagsStore } from "@/stores/feature-flags-store";
import { FEATURE_FLAGS, isPrivilegedUser } from "@/lib/feature-flags";

export const FeatureFlagsMenu = () => {
  const { user } = useAuth();
  const flags = useFeatureFlagsStore((s) => s.flags);
  const setFlag = useFeatureFlagsStore((s) => s.setFlag);

  if (!isPrivilegedUser(user?.email)) return null;

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger className="flex items-center gap-2 cursor-pointer min-h-touch">
        <Flag className="w-4 h-4" />
        <span>Feature Flags</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="w-56">
        {FEATURE_FLAGS.length === 0 ? (
          <DropdownMenuItem disabled>No flags</DropdownMenuItem>
        ) : (
          FEATURE_FLAGS.map((flag) => {
            const checked = flags[flag.key] ?? flag.defaultValue ?? false;
            return (
              <DropdownMenuCheckboxItem
                key={flag.key}
                checked={checked}
                onSelect={(e) => e.preventDefault()}
                onCheckedChange={(value) => setFlag(flag.key, value)}
              >
                <div className="flex flex-col">
                  <span>{flag.label}</span>
                  {flag.description && (
                    <span className="text-xs text-muted-foreground">
                      {flag.description}
                    </span>
                  )}
                </div>
              </DropdownMenuCheckboxItem>
            );
          })
        )}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};
